import { BrowserRouter } from 'react-router-dom';

export const Router: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return <BrowserRouter>{children}</BrowserRouter>;
};
